import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import TagsInput from "../../../components/input/tags/tags-input";
import { GetAllItems, UpdateItem } from "../../../utils/functions";
import { toast } from "react-toastify";
import Uploader from '../../../components/Uploader/Uploader';
import { Checkbox } from "primereact/checkbox";
import { TabContext, TabList } from "@mui/lab";
import { Tab, Typography, Box } from "@mui/material";
import Select from "react-select";
import { DataContext } from '../../../App';
import { Editor } from 'primereact/editor';
import { NavLink } from 'react-router-dom';
import LoadingApp from "../../../components/loadingApp/loadingApp";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const ManageHome = (page, isEditable) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const context = useContext(DataContext);
  const currentPage = page["page"].toLowerCase();
  const [homeDetails, setHomeDetails] = useState(null)
  const [id, setId] = useState(null);
  const [valueTab, setValueTab] = useState(0);
  const [isBtnDisable, setIsBtnDisable] = useState(false);

  const [isMobileTablet, setIsMobileTablet] = useState(window.matchMedia("(max-width: 991px)").matches);
  const [formValues, setFormValues] = useState({
    id: id,
    seoInformation: {
      title: null,
      metaDescription: null,
      linkUrl: null,
      keywords: null,
    },
    cover: {
      description: null,
      title: null,
      image: null,
      cta: {
        text: null,
        url: null,
        target: null,
      },
      isActive: false,
    },
    heading: {
      title: null,
      image: null,
      description: null,
      cta: null,
    },
    intro: {
      title: null,
      image: null,
      description: null,
      cta: null,
    },
    experiences: [
      {
        title: null,
        description: null,
        image: null,
        cta: {
          text: null,
          url: null,
          target: null,
        },
      },
      {
        title: null,
        description: null,
        image: null,
        cta: {
          text: null,
          url: null,
          target: null,
        },
      },
      {
        title: null,
        description: null,
        image: null,
        cta: {
          text: null,
          url: null,
          target: null,
        },
      },
      {
        title: null,
        description: null,
        image: null,
        cta: {
          text: null,
          url: null,
          target: null,
        },
      },
    ],
    concierge: {
      title: null,
      description: null,
      image: null,
      cta: {
        text: null,
        url: null,
        target: null,
      },
    },
  });

  const optionsCTATarget = [
    {
      label: t("SamePage"),
      value: "_self"
    },
    {
      label: t("OtherPage"),
      value: "_blank"
    }
  ];

  const handleGalleryFiles = (filePaths, section) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [section]: {
        ...prevValues[section],
        image: [filePaths[filePaths.length - 1]]
      }
    }));
  };

  const handleGalleryExperiencesFiles = (filePaths, index) => {
    const updatedExperiences = formValues?.experiences?.map((experience, i) =>
      i === index ? { ...experience, image: [filePaths[filePaths.length - 1]] } : experience
    );
    setFormValues((prevValues) => ({
      ...prevValues,
      experiences: updatedExperiences,
    }));
  };

  
  const handleRemoveImage = (section) => {
    setFormValues((prevValues) => {
      const updatedValues = { ...prevValues };
      updatedValues[section].image = null; 
      
      return updatedValues;
    });
  };

  const handleRemoveExperiencesImage = (section, index) => {
    setFormValues((prevValues) => {
      const updatedValues = { ...prevValues };
      updatedValues[section][index].image = null;
      
      return updatedValues;
    });
  };

  const handleChange = (event, newValue) => {
    setValueTab(newValue);
  };

  const selectedTags = (tags) => {
    const newKeywords = [...tags];
    setFormValues((prevValues) => ({
      ...prevValues,
      seoInformation: {
        ...prevValues.seoInformation,
        keywords: newKeywords
      }
    }));
  };

  const checkValues = () => {
    if (!formValues?.seoInformation.title) {
      toast.error(t("ToastErrorTitleSeoRequired"));
      return false;
    }

    if (formValues?.cover.isActive) {
      if (!formValues?.cover.description) {
        toast.error(t("ToastErrorCoverUpTitleHomeRequired"));
        return false;
      }

      if (!formValues?.cover.title) {
        toast.error(t("ToastErrorCoverTitleHomeRequired"));
        return false;
      }

      if (!formValues?.cover.cta.text) {
        toast.error(t("ToastErrorCoverCtaTextHomeRequired"));
        return false;
      }

      if (!formValues?.cover.image || (formValues?.cover.image && formValues?.cover.image.length > 0 && !formValues?.cover.image[0])) {
        toast.error(t("ToastErrorCoverImageRequired"));
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsBtnDisable(true);

    if (checkValues()) {
      const resp = await UpdateItem("Page", formValues, "home");
      if (resp) {
        await context.updateData("pages", currentPage);
        navigate("/admin/pages");
      }
    }

    setIsBtnDisable(false);
  };

  useEffect(() => {
    const fetchHome = async () => {
      if (!homeDetails) {
        const data = await GetAllItems("Page", true, currentPage);
        if (data && data.length > 0) {
          setId(data[0].id);
          setHomeDetails(data[0].pageContent);
        }
      }
    };
    fetchHome();
  }, []);

  useEffect(() => {
    if (homeDetails) {
      setFormValues({
        id: homeDetails.id,
        seoInformation: {
          title: homeDetails?.seoInformation?.title ?? null,
          metaDescription: homeDetails?.seoInformation?.metaDescription ?? null,
          linkUrl: null,
          keywords: homeDetails?.seoInformation?.keywords ?? [],
        },
        cover: {
          description: homeDetails?.cover?.description ?? null,
          title: homeDetails?.cover?.title ?? null,
          image: homeDetails?.cover?.image ? homeDetails?.cover?.image : null,
          cta: {
            text: homeDetails?.cover?.cta?.text ?? null,
            url: null,
            target: null,
          },
          isActive: homeDetails?.cover?.isActive ?? false,
        },
        heading: {
          title: homeDetails?.heading?.title ?? null,
          image: homeDetails?.heading?.image ? homeDetails?.heading?.image : null,
          description: null,
          cta: null
        },
        intro: {
          title: homeDetails?.intro?.title ?? null,
          image: null,
          description: null,
          cta: null
        },
        experiences: [
          {
            title: homeDetails?.experiences && homeDetails.experiences[0]?.title ? homeDetails.experiences[0]?.title : null,
            description: homeDetails?.experiences && homeDetails.experiences[0]?.description ? homeDetails.experiences[0]?.description : null,
            image: null,
            cta: {
              text: homeDetails?.experiences && homeDetails.experiences[0]?.cta?.text ? homeDetails.experiences[0]?.cta?.text : null,
              url: homeDetails?.experiences && homeDetails.experiences[0]?.cta?.url ? homeDetails.experiences[0]?.cta?.url : null,
              target: homeDetails?.experiences && homeDetails.experiences[0]?.cta?.target ? homeDetails.experiences[0]?.cta?.target : "_self",
            },
          },
          {
            title: homeDetails?.experiences && homeDetails.experiences[1]?.title ? homeDetails.experiences[1]?.title : null,
            description: homeDetails?.experiences && homeDetails.experiences[1]?.description ? homeDetails.experiences[1]?.description : null,
            image: homeDetails?.experiences && homeDetails.experiences[1]?.image ? homeDetails.experiences[1]?.image : null,
            cta: {
              text: null,
              url: homeDetails?.experiences && homeDetails.experiences[1]?.cta?.url ? homeDetails.experiences[1]?.cta?.url : null,
              target: "_self",
            },
          },
          {
            title: homeDetails?.experiences && homeDetails.experiences[2]?.title ? homeDetails.experiences[2]?.title : null,
            description: homeDetails?.experiences && homeDetails.experiences[2]?.description ? homeDetails.experiences[2]?.description : null,
            image: homeDetails?.experiences && homeDetails.experiences[2]?.image ? homeDetails.experiences[2]?.image : null,
            cta: {
              text: null,
              url: homeDetails?.experiences && homeDetails.experiences[2]?.cta?.url ? homeDetails.experiences[2]?.cta?.url : null,
              target: "_self",
            },
          },
          {
            title: homeDetails?.experiences && homeDetails.experiences[3]?.title ? homeDetails.experiences[3]?.title : null,
            description: homeDetails?.experiences && homeDetails.experiences[3]?.description ? homeDetails.experiences[3]?.description : null,
            image: homeDetails?.experiences && homeDetails.experiences[3]?.image ? homeDetails.experiences[3]?.image : null,
            cta: {
              text: null,
              url: homeDetails?.experiences && homeDetails.experiences[3]?.cta?.url ? homeDetails.experiences[3]?.cta?.url : null,
              target: "_self",
            },
          },
        ],
        concierge: {
          title: homeDetails?.concierge?.title ?? null,
          description: homeDetails?.concierge?.description ?? null,
          image: homeDetails?.concierge?.image ? homeDetails?.concierge?.image : null,
          cta: {
            text: homeDetails?.concierge?.cta?.text ?? null,
            url: homeDetails?.concierge?.cta?.url ?? null,
            target: homeDetails?.concierge?.cta?.target ?? null,
          },
        },
      });
    }
  }, [homeDetails]);

  if (!homeDetails) {
    return <LoadingApp />;
  }

  return (
    <div className="container-admin mt-5">
      <div className="row">
        <NavLink className="come-back-admin" to={"/admin/pages"}>
          <FontAwesomeIcon icon={faAngleLeft} />
          {t("Back")}
        </NavLink>
        {/* SEO */}
        <div className="row mt-5 mb-5">
          <div className="mb-5">
            <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
              {t("Seo")}
            </h5>
            <p>{t("ExperiencesSeoInformations")}</p>
          </div>
          <div className="flex-wrap col-lg-6 col-12 my-3">
            <div className="d-flex flex-column position-relative">
              <label className={`ms-1 fs-6 text-black w-full mb-2`}>
                {t("Title")}<span className="text-danger">*</span>
              </label>
              <textarea
                maxLength={60}
                value={formValues?.seoInformation?.title}
                className="grey-input w-100 min-h-100px"
                placeholder={t("Insert")}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    seoInformation: {
                      ...prevValues.seoInformation,
                      title: e.target.value,
                    },
                  }))
                }
              ></textarea>
              <p className="paragraph position-absolute end-0 top-100 font-description-small">
                {t("Max60")}
              </p>
            </div>
          </div>
          <div className="flex-wrap col-lg-6 col-12 my-3">
            <div className="d-flex flex-column position-relative">
              <label className={`ms-1 fs-6 text-black w-full mb-2`}>
                {t("MetaDescription")}
              </label>
              <textarea
                maxLength={160}
                value={formValues?.seoInformation?.metaDescription}
                className="grey-input w-100 min-h-100px"
                placeholder={t("Insert")}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    seoInformation: {
                      ...prevValues.seoInformation,
                      metaDescription: e.target.value,
                    },
                  }))
                }
              ></textarea>
              <p className="paragraph position-absolute end-0 top-100 font-description-small ">
                {t("Max160")}
              </p>
            </div>
          </div>
          <div className="flex-wrap col-lg-6 col-12 my-3">
            <TagsInput
              label={t("Keywords")}
              key={formValues?.seoInformation?.keywords?.join(",")}
              placeholder={t("KeywordsPlaceholder")}
              selectedTags={selectedTags}
              defaultTags={formValues?.seoInformation?.keywords ?? []}
            />
          </div>
        </div>
        <hr />
        {/* COVER */}
        <div className="row mt-5 mb-5">
          <div className="mb-5">
            <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
              {t("Cover")}
            </h5>
            <p>{t("HomePageCoverDescription")}</p>
          </div>
          <div className="col-lg-6">
            <label className="ms-1 fs-6 text-black mb-2">
              {t("UpTitle")}<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="coverDescription"
              placeholder={t("Insert")}
              value={formValues?.cover?.description}
              onChange={(value) => setFormValues(prevValues => ({
                ...prevValues,
                cover: {
                  ...prevValues.cover,
                  description: value.target.value,
                }
              }))}
              className="grey-input w-100"
            />
          </div>
          <div className="col-lg-6">
            <label className="ms-1 fs-6 text-black mb-2">
              {t("Title")}<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="coverTitle"
              placeholder={t("Insert")}
              value={formValues?.cover?.title}
              onChange={(value) => setFormValues(prevValues => ({
                ...prevValues,
                cover: {
                  ...prevValues.cover,
                  title: value.target.value,
                }
              }))}
              className="grey-input w-100"
            />
          </div>
          <div className="col-lg-6 mt-5">
            <label className="ms-1 fs-6 text-black mb-2">
              {t("GoDownText")}<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="coverCtaText"
              placeholder={t("Insert")}
              value={formValues?.cover?.cta?.text}
              onChange={(value) =>
                setFormValues((prevValues) => ({
                  ...prevValues,
                  cover:
                  {
                    ...prevValues.cover,
                    cta: { ...prevValues.cover?.cta, text: value.target.value },
                  },
                }))
              }
              className="grey-input w-100"
            />
          </div>
          <div className="flex-wrap col-lg-6 mt-5">
            <label
              className={`ms-1 fs-6 text-black w-full mb-2`}
            >
              {t("Active")}
            </label>
            <div className="d-flex">
              <label className="flex-wrap my-3 me-5">
                <Checkbox
                  onClick={() => setFormValues(prevValues => ({
                    ...prevValues,
                    cover: {
                      ...prevValues.cover,
                      isActive: true,
                    }
                  }))}
                  className={"checkbox-admin me-1"}
                  checked={formValues?.cover?.isActive}
                />
                <span className="ms-1">{t("Yes")}</span>
              </label>
              <label className="flex-wrap my-3">
                <Checkbox
                  onClick={() => setFormValues(prevValues => ({
                    ...prevValues,
                    cover: {
                      ...prevValues.cover,
                      isActive: false,
                    }
                  }))}
                  className={"checkbox-admin me-1"}
                  checked={!formValues?.cover?.isActive}
                />
                <span className="ms-1">{t("No")}</span>
              </label>
            </div>
          </div>
          <div className="d-flex flex-column fw-bold text-uppercase col-12 mt-5">
            <Uploader 
              onChange={(files) => handleGalleryFiles(files, 'cover')} 
              onRemove={() => handleRemoveImage("cover")} 
              value={formValues?.cover?.image ?? []} 
            />
          </div>
        </div>
        <hr />
        {/* HEADING */}
        <div className="row mt-5 mb-5">
          <div className="mb-5">
            <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
              {t("Heading")}
            </h5>
            <p>{t("HomePageHeadingInformations")}</p>
          </div>
          <div className="col-lg-6">
            <label className="ms-1 fs-6 text-black mb-2">{t("Title")}</label>
            <input
              type="text"
              name="headingTitle"
              placeholder={t("Insert")}
              value={formValues?.heading?.title}
              onChange={(value) => setFormValues(prevValues => ({
                ...prevValues,
                heading: {
                  ...prevValues.heading,
                  title: value.target.value,
                }
              }))}
              className="grey-input w-100"
            />
          </div>
          <div className="d-flex flex-column fw-bold text-uppercase col-12 mt-5">
            <Uploader 
              onChange={(files) => handleGalleryFiles(files, 'heading')} 
              value={formValues?.heading?.image ?? []} 
              onRemove={() => handleRemoveImage("heading")} 
              fileType={".mp4"} 
            />
          </div>
        </div>
        <hr />
        {/* INTRO */}
        <div className="row mt-5 mb-5">
          <div className="mb-5">
            <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
              {t("Intro")}
            </h5>
            <p>{t("HomePageIntroDescription")}</p>
          </div>
          <div className="col-lg-6">
            <label className="ms-1 fs-6 text-black mb-2">{t("Title")}</label>
            <input
              type="text"
              name="introTitle"
              placeholder={t("Insert")}
              value={formValues?.intro?.title}
              onChange={(value) => setFormValues(prevValues => ({
                ...prevValues,
                intro: {
                  ...prevValues.intro,
                  title: value.target.value,
                }
              }))}
              className="grey-input w-100"
            />
          </div>
        </div>
        <hr />
        {/* EXPERIENCES */}

        <div className="row">
          <div className="row mt-5 mb-5">
            <div className="mb-5">
              <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                {t("Experiences")}
              </h5>
              <p>{t("HomePageExperiencesInformation")}</p>
            </div>
          </div>
          <TabContext
            className={"d-flex mt-5 pt-5"}
            value={valueTab}
          >
            <TabList
              orientation="vertical"
              onChange={handleChange}
              aria-label=""
              className="custom-tabs-property col-lg-4 ps-0"
            >
              <Tab
                value={0}
                label={t("Description")}
                className="text-black text-start"
              />
              <Tab
                value={1}
                label={t("FirstExperience")}
                className="text-black text-start"
              />
              <Tab
                value={2}
                label={t("SecondExperience")}
                className="text-black text-start"
              />
              <Tab
                value={3}
                label={t("ThirdExperience")}
                className="text-black text-start"
              />
            </TabList>
            <div className="col-lg-8">
              <TabPanel
                value={valueTab}
                index={0}
                className="custom-panels-admin-area pe-2"
              >
                <div className="row mb-5">
                  <div className="col-lg-12">
                    <label className="ms-1 fs-6 text-black mb-2">{t("Title")}</label>
                    <input
                      type="text"
                      name="experienceOneTitle"
                      placeholder={t("Insert")}
                      value={formValues?.experiences[0].title}
                      onChange={(value) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          experiences: [
                            { ...prevValues.experiences[0], title: value.target.value },
                            ...prevValues.experiences.slice(1),
                          ],
                        }))
                      }
                      className="grey-input w-100"
                    />
                  </div>
                  <div className="col-lg-12 mt-5">
                    <label className="ms-1 fs-6 text-black mb-2">{t("Description")}</label>
                    <Editor
                      value={formValues?.experiences[0].description}
                      onTextChange={(e) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          experiences: [

                            { ...prevValues.experiences[0], description: e.htmlValue },
                            ...prevValues.experiences.slice(1),
                          ],
                        }))
                      }
                      placeholder={t("Insert")}
                      className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                    />
                  </div>
                  <div className="col-lg-4 mt-5">
                    <label className="ms-1 fs-6 text-black mb-2">{t("CtaText")}</label>
                    <input
                      type="text"
                      name="experiencesOneCtaText"
                      placeholder={t("Insert")}
                      value={formValues?.experiences[0].cta?.text}
                      onChange={(value) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          experiences: [
                            {
                              ...prevValues.experiences[0],
                              cta: { ...prevValues.experiences[0].cta, text: value.target.value },
                            },
                            ...prevValues.experiences.slice(1),
                          ],
                        }))
                      }
                      className="grey-input w-100"
                    />
                  </div>
                  <div className="col-lg-4 mt-5">
                    <label className="ms-1 fs-6 text-black mb-2">{t("CtaUrl")}</label>
                    <input
                      type="text"
                      name="experiencesOneCtaUrl"
                      placeholder={t("Insert")}
                      value={formValues?.experiences[0].cta?.url}
                      onChange={(value) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          experiences: [
                            {
                              ...prevValues.experiences[0],
                              cta: { ...prevValues.experiences[0].cta, url: value.target.value },
                            },
                            ...prevValues.experiences.slice(1),
                          ],
                        }))
                      }
                      className="grey-input w-100"
                    />
                  </div>
                  <div className="flex-wrap col-lg-4 mt-5">
                    <div className="d-flex flex-column">
                      <label
                        className={`ms-1 fs-6 text-black w-full mb-2`}
                      >
                        {t("CtaTarget")}
                      </label>
                      <Select
                        options={optionsCTATarget}
                        placeholder={t("Select")}
                        className="grey-select"
                        isSearchable={false}
                        onChange={(value) =>
                          setFormValues((prevValues) => ({
                            ...prevValues,
                            experiences: [
                              ...prevValues.experiences.slice(0, 1),
                              {
                                ...prevValues.experiences[0],
                                cta: { ...prevValues.experiences[0].cta, target: value.value },
                              },
                              ...prevValues.experiences.slice(1),
                            ],
                          }))
                        }
                        value={optionsCTATarget.find(
                          (option) => option.value === formValues?.experiences[0].cta?.target
                        )}
                      />
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel
                value={valueTab}
                index={1}
                className="custom-panels-admin-area pe-2"
              >
                <div className="row">
                  <div className="col-lg-6">
                    <label className="ms-1 fs-6 text-black mb-2">{t("Title")}</label>
                    <input
                      type="text"
                      name="experienceTwoTitle"
                      placeholder={t("Insert")}
                      value={formValues?.experiences[1].title}
                      onChange={(value) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          experiences: [
                            ...prevValues.experiences.slice(0, 1),
                            { ...prevValues.experiences[1], title: value.target.value },
                            ...prevValues.experiences.slice(2),
                          ],
                        }))
                      }
                      className="grey-input w-100"
                    />
                  </div>
                  <div className="col-lg-6">
                    <label className="ms-1 fs-6 text-black mb-2">{t("CtaUrl")}</label>
                    <input
                      type="text"
                      name="experienceTwoCtaUrl"
                      placeholder={t("Insert")}
                      value={formValues?.experiences[1].cta?.url}
                      onChange={(value) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          experiences: [
                            ...prevValues.experiences.slice(0, 1),
                            {
                              ...prevValues.experiences[1],
                              cta: { ...prevValues.experiences[1].cta, url: value.target.value },
                            },
                            ...prevValues.experiences.slice(2),
                          ],
                        }))
                      }
                      className="grey-input w-100"
                    />
                  </div>
                  <div className="col-lg-12 mt-5">
                    <label className="ms-1 fs-6 text-black mb-2">{t("Description")}</label>
                    <Editor
                      value={formValues?.experiences[1].description}
                      onTextChange={(e) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          experiences: [
                            ...prevValues.experiences.slice(0, 1),
                            { ...prevValues.experiences[1], description: e.htmlValue },
                            ...prevValues.experiences.slice(2),
                          ],
                        }))
                      }

                      className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                      placeholder={t("Insert")}

                    />
                  </div>
                  <div className="overflow-auto col-lg-12">
                    <div className="d-flex flex-column fw-bold text-uppercase col-12 mt-5">
                      <Uploader
                        onChange={(files) => handleGalleryExperiencesFiles(files, 1)}
                        onRemove={() => handleRemoveExperiencesImage("experiences", 1)}
                        value={formValues?.experiences[1].image ?? []}
                      />
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel
                value={valueTab}
                index={2}
                className="custom-panels-admin-area pe-2"
              >
                <div className="row">
                  <div className="col-lg-6">
                    <label className="ms-1 fs-6 text-black mb-2">{t("Title")}</label>
                    <input
                      type="text"
                      name="experienceThreeTitle"
                      placeholder={t("Insert")}
                      value={formValues?.experiences[2].title}
                      onChange={(value) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          experiences: [
                            ...prevValues.experiences.slice(0, 2),
                            { ...prevValues.experiences[2], title: value.target.value },
                            ...prevValues.experiences.slice(3),
                          ],
                        }))
                      }
                      className="grey-input w-100"
                    />
                  </div>
                  <div className="col-lg-6">
                    <label className="ms-1 fs-6 text-black mb-2">{t("CtaUrl")}</label>
                    <input
                      type="text"
                      name="experienceThreeCtaUrl"
                      placeholder={t("Insert")}
                      value={formValues?.experiences[2].cta?.url}
                      onChange={(value) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          experiences: [
                            ...prevValues.experiences.slice(0, 2),
                            {
                              ...prevValues.experiences[2],
                              cta: { ...prevValues.experiences[2].cta, url: value.target.value },
                            },
                            ...prevValues.experiences.slice(3),
                          ],
                        }))
                      }
                      className="grey-input w-100"
                    />
                  </div>
                  <div className="col-lg-12 mt-5">
                    <label className="ms-1 fs-6 text-black mb-2">{t("Description")}</label>
                    <Editor
                      value={formValues?.experiences[2].description}
                      onTextChange={(e) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          experiences: [
                            ...prevValues.experiences.slice(0, 2),
                            { ...prevValues.experiences[2], description: e.htmlValue },
                            ...prevValues.experiences.slice(3),
                          ],
                        }))
                      }

                      className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                      placeholder={t("Insert")}

                    />
                  </div>
                  <div className="overflow-auto col-lg-12">
                    <div className="d-flex flex-column fw-bold text-uppercase col-12 mt-5">
                      <Uploader
                        onChange={(files) => handleGalleryExperiencesFiles(files, 2)}
                        onRemove={() => handleRemoveExperiencesImage("experiences", 2)}
                        value={formValues?.experiences[2].image ?? []}
                      />
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel
                value={valueTab}
                index={3}
                className="custom-panels-admin-area pe-2"
              >
                <div className="row">
                  <div className="col-lg-6">
                    <label className="ms-1 fs-6 text-black mb-2">{t("Title")}</label>
                    <input
                      type="text"
                      name="experienceFourTitle"
                      placeholder={t("Insert")}
                      value={formValues?.experiences[3].title}
                      onChange={(value) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          experiences: [
                            ...prevValues.experiences.slice(0, 3),
                            { ...prevValues.experiences[3], title: value.target.value },
                          ],
                        }))
                      }
                      className="grey-input w-100"
                    />
                  </div>
                  <div className="col-lg-6">
                    <label className="ms-1 fs-6 text-black mb-2">{t("CtaUrl")}</label>
                    <input
                      type="text"
                      name="experienceFourCtaUrl"
                      placeholder={t("Insert")}
                      value={formValues?.experiences[3].cta?.url}
                      onChange={(value) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          experiences: [
                            ...prevValues.experiences.slice(0, 3),
                            {
                              ...prevValues.experiences[3],
                              cta: { ...prevValues.experiences[3].cta, url: value.target.value },
                            },
                          ],
                        }))
                      }
                      className="grey-input w-100"
                    />
                  </div>
                  <div className="col-lg-12 mt-5">
                    <label className="ms-1 fs-6 text-black mb-2">{t("Description")}</label>
                    <Editor
                      value={formValues?.experiences[3].description}
                      onTextChange={(e) =>
                        setFormValues((prevValues) => ({
                          ...prevValues,
                          experiences: [
                            ...prevValues.experiences.slice(0, 3),
                            { ...prevValues.experiences[3], description: e.htmlValue },
                          ],
                        }))
                      }

                      className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
                      placeholder={t("Insert")}
                    />
                  </div>
                  <div className="overflow-auto col-lg-12">
                    <div className="d-flex flex-column fw-bold text-uppercase col-12 mt-5">
                      <Uploader
                        onChange={(files) => handleGalleryExperiencesFiles(files, 3)}
                        onRemove={() => handleRemoveExperiencesImage("experiences", 3)}
                        value={formValues?.experiences[3].image ?? []}
                      />
                    </div>
                  </div>
                </div>
              </TabPanel>
            </div>
          </TabContext>
        </div>
        <hr />
        {/* CONCIERGE */}
        <div className="row mt-5 mb-5">
          <div className="mb-5">
            <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
              {t("Concierge")}
            </h5>
            <p>{t("HomePageConciergeDescription")}</p>
          </div>
          <div className="col-lg-6">
            <label className="ms-1 fs-6 text-black mb-2">{t("Title")}</label>
            <input
              type="text"
              name="conciergeTitle"
              placeholder={t("Insert")}
              value={formValues?.concierge.title}
              onChange={(value) => setFormValues(prevValues => ({
                ...prevValues,
                concierge: {
                  ...prevValues.concierge,
                  title: value.target.value,
                }
              }
              ))}
              className="grey-input w-100"
            />
          </div>
          <div className="col-lg-12 mt-3">
            <label className="ms-1 fs-6 text-black mb-2">{t("Description")}</label>
            <Editor
              value={formValues?.concierge.description}
              onTextChange={(e) =>
                setFormValues((prevValues) => ({
                  ...prevValues,
                  concierge: {
                    ...prevValues.concierge,
                    description: e.htmlValue,
                  }
                }))
              }

              className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
              placeholder={t("Insert")}
            />
          </div>
          <div className="col-lg-4 mt-5">
            <label className="ms-1 fs-6 text-black mb-2">{t("CtaText")}</label>
            <input
              type="text"
              name="conciergeCtaText"
              placeholder={t("Insert")}
              value={formValues?.concierge.cta?.text}
              onChange={(value) => setFormValues(prevValues => ({
                ...prevValues,
                concierge: {
                  ...prevValues.concierge,
                  cta: {
                    ...prevValues.concierge.cta,
                    text: value.target.value
                  },
                }
              }
              ))}
              className="grey-input w-100"
            />
          </div>
          <div className="col-lg-4 mt-5">
            <label className="ms-1 fs-6 text-black mb-2">{t("CtaUrl")}</label>
            <input
              type="text"
              name="conciergeCtaUrl"
              placeholder={t("Insert")}
              value={formValues?.concierge.cta?.url}
              onChange={(value) => setFormValues(prevValues => ({
                ...prevValues,
                concierge: {
                  ...prevValues.concierge,
                  cta: {
                    ...prevValues.concierge.cta,
                    url: value.target.value
                  },
                }
              }
              ))}
              className="grey-input w-100"
            />
          </div>
          <div className="flex-wrap col-lg-4 mt-5">
            <div className="d-flex flex-column">
              <label
                className={`ms-1 fs-6 text-black w-full mb-2`}
              >
                {t("CtaTarget")}
              </label>
              <Select
                options={optionsCTATarget}
                placeholder={t("Select")}
                className="grey-select"
                isSearchable={false}
                onChange={(value) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    concierge: {
                      ...prevValues.concierge,
                      cta: {
                        ...prevValues.concierge.cta,
                        target: value.value
                      },
                    }
                  }))
                }
                value={optionsCTATarget.find(
                  (option) => option.value === formValues?.concierge?.cta?.target
                )}
              />
            </div>
          </div>
          <div className="d-flex flex-column fw-bold text-uppercase col-12 mt-5">
            <Uploader 
              onChange={(files) => handleGalleryFiles(files, 'concierge')} 
              onRemove={() => handleRemoveImage("concierge")} 
              value={formValues?.concierge.image ?? []} 
            />
          </div>
          <div className="col-lg-12 mt-3 d-flex justify-content-end">
            <button
              onClick={handleSubmit}
              disabled={isBtnDisable}
              className="admin-button border-none text-uppercase">
              {t("Update")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageHome;
